import { flatten, without } from 'ramda';
import * as React from 'react';

import { FDealType, FOfferType } from '../../../../../JsonQuery';
import { getOfferTypeLabel } from '../../../utils/offerType';
import { Select, Option } from '../../Select';
import { CommercialLink } from './components/CommercialLink';
import { getOfferTypeList } from './helpers';

interface IOfferTypeProps {
  dealType: FDealType;
  value: FOfferType;
  commercialLink: string;
  onChange(value: FOfferType): void;
}

export const OfferType: React.FC<IOfferTypeProps> = ({ dealType, value, commercialLink, onChange }) => {
  const offerTypes = getOfferTypeList(dealType, value);
  const offerTypeLabel = getOfferTypeLabel(dealType, value);

  const selectedOptions = flatten(offerTypes)
    .filter(offerType => (value & offerType.value) !== 0)
    .map(offerType => offerType.value);

  return (
    <Select
      multiple
      withoutArrow
      label={offerTypeLabel || undefined}
      placeholder="Тип предложения"
      value={selectedOptions}
      onChange={(_, selectedValues: FOfferType[]) => {
        const selectedOfferType = without(
          selectedOptions.length < selectedValues.length ? selectedOptions : selectedValues,
          selectedOptions.length < selectedValues.length ? selectedValues : selectedOptions,
        )[0];

        if (selectedOfferType === value) {
          return;
        }

        onChange(selectedOfferType);
      }}
      popupPostfix={dealType !== FDealType.RentDaily ? <CommercialLink href={commercialLink} /> : null}
    >
      {offerTypes.map(parts =>
        parts.map(offerType => (
          <Option key={`${offerType.label}_${offerType.value}`} value={offerType.value}>
            {offerType.label}
          </Option>
        )),
      )}
    </Select>
  );
};
